export const biografias = [
    {
      cod: "1",
      imagem: `${process.env.PUBLIC_URL}/assets/01.webp`,
      nome: "Alex Melo",
      partido: "Partido Renovação Democrática (PRD)",
      nomeCivil: "Alecsandro de Melo",
      telefone: "(79) 0000-0000",
      celular: "(79) 00000-0000",
      email: "alexmelo@aracaju.se.leg.br",
      gabinete: "Rua, Nº Aracaju",
      biografia:
        "Alecsandro de Melo, conhecido como Alex Melo, nasceu em Guarulhos (SP), em 21 de julho de 1982. Formado em Gestão Pública, é pastor da Igreja Universal há 26 anos e atua como coordenador político da instituição em Sergipe. Em 2022, Alex disputou o cargo de deputado federal, alcançando 16.203 votos. Em 2024, foi eleito como vereador de Aracaju pelo PRD com 2.938 votos. Entre suas principais bandeiras estão o incentivo ao esporte, a inclusão social, o apoio à causa animal e a assistência às crianças com autismo",
      comissoes: [
        {
          cargo: "Membro",
          permanente: "Obras, Serviços Públicos, Tecnologia, Segurança, Administração, Transportes e Comércio",
        },
      ],
      facebookLink:"https://www.facebook.com/alecsandro.melo.10?mibextid=LQQJ4d&rdid=9rKYYaphpelRUSDv&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2FtdcYG9C4RJRZsxXh%2F%3Fmibextid%3DLQQJ4d#",
      instagramLink:"https://www.instagram.com/alexmelo25oficial/?igsh=Zm9kNjJtY2N5cGpk#",
      youtubeLink:"https://www.youtube.com/@alexmelo4195",
      XLink:"https://www.youtube.com/@alexmelo4195",
      LinkSite: "",
    },

    {
        cod: "2",
        imagem: `${process.env.PUBLIC_URL}/assets/02.webp`,
        nome: "Anderson de Tuca",
        partido: "União Brasil",
        nomeCivil: "Anderson Santos da Silva",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "andersondetuca@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Anderson Santos da Silva, conhecido como Anderson de Tuca (PDT), nasceu em 21 de agosto de 1988. É bacharel em Direito, funcionário público concursado do Departamento Estadual de Trânsito de Sergipe (Detran-SE) desde 2010 e vereador da Câmara Municipal de Aracaju desde 2013 e segue para o seu quarto mandato consecutivo.",
        comissoes: [
          {
            cargo: "Secretário",
            permanente: "Constituição, Justiça e Redação",
          },
        ],
        facebookLink:"https://www.facebook.com/andersondetuca/",
        instagramLink:"https://www.instagram.com/anderson.de.tuca/",
        youtubeLink:"",
        XLink:"",
      },
     
      {
        cod: "3",
        imagem: `${process.env.PUBLIC_URL}/assets/03.webp`,
        nome: "Bigode do Santa Maria",
        partido: "Partido Social Democrático (PSD)",
        nomeCivil: "José Américo dos Santos Silva",
        telefone: "(79) 0000-0000",
        celular: "(79) 00000-0000",
        email: "bigodedosantamaria@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia: "José Américo dos Santos, conhecido como Bigode do Santa Maria (PSD), nasceu em 20 de junho de 1947. Casado e tem 7 filhos." +
                   "Trabalhou como cabeleireiro durante 45 anos. Bigode foi presidente do Projeto Nordeste, presidente da Associação de Moradores de Ilha das Flores e presidente da Associação de Bairros de Aracaju",
        comissoes: [
          {
            cargo: "Membro",
            permanente: "Educação, Cultura, Esportes, Lazer e Turismo.",
                        
          },
          {
            cargo: "Membro",
            permanente: "Assistência Social, Direitos Humanos, Defesa Do Consumidor, Criança, Adolescente e da Mulher.",
                        
          },
        ],
        facebookLink:"https://www.facebook.com/vereadorbigodeAju",
        instagramLink:"",
        youtubeLink:"",
        XLink:"",
      },      
      
      {
        cod: "4",
        imagem: `${process.env.PUBLIC_URL}/assets/04.webp`,
        nome: "Binho",
        partido: "Podemos",
        nomeCivil: "Adeilson Soares dos Santos",
        telefone: "(79) 0000-0000",
        celular: "(79) 00000-0000",
        email: "binho@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Adeilson Soares dos Santos, conhecido como Binho (PMN), nasceu em 18 de novembro de 1982. É formado em Educação Física pela Faculdade Fase. No ano de 2001, ganhou as eleições para presidente do grêmio estudantil do Colégio José Rollemberg Leite, com 501 votos. Em 2000, foi diretor da União Sergipana dos Estudantes Secundários (USES), fundador da Escolinha de Futsal Craque da Bola e idealizador do projeto social “Eu e Meu Bairro Somos um Só”. Em 2025, exercerá o segundo mandato como vereador. ",
        comissoes: [
          {
            cargo: "",
            permanente: "",
          }, 
        ],
        facebookLink:"",
        instagramLink:"https://www.instagram.com/vereadorbinho.oficial/",
        youtubeLink:"",
        XLink:"",
      },
      
      {
        cod: "5",
        imagem: `${process.env.PUBLIC_URL}/assets/05.webp`,
        nome: "Breno Garibalde",
        partido: "Partido Socialista Brasileiro (PSB)",
        nomeCivil: "Breno Viana de Mendonça",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "brenogaribalde@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
        "Breno Viana de Mendonça, conhecido como Breno Garibalde (REDE), nasceu em 8 de setembro de 1988. É formado pela Universidade Belas Artes, mestre em urbanismo e também possui no portfólio uma formação pela escola de preparação política RenovaBR. O parlamentar é especialista em processos de participação cidadã e projetos urbanísticos. Estudou em São Paulo e na Itália em busca de conhecimento e formas para que, junto com as pessoas, fosse possível planejar, construir, fazer e reinventar uma Aracaju melhor para todos, com ideias e projetos voltados para sustentabilidade, mobilidade, criatividade, participação e transparência. Em 2025, Breno irá para o seu segundo mandato.",
        comissoes: [
          {
            cargo: "Secretário",
            permanente: "Obras, Serviços Públicos, Tecnologia, Segurança, Administração, Transportes e Comércio",
          },
          {
            cargo: "Presidente",
            permanente: "Saúde, Meio Ambiente e Proteção Animal.",
          },
          {
            cargo: "Membro",
            permanente: "Processante e Ética.",
          },          
        ],
        facebookLink:"https://www.facebook.com/BrenoGaribaldeOficial/",
        instagramLink:"https://www.instagram.com/brenogaribalde/",
        youtubeLink:"https://www.youtube.com/watch?v=YKPsNVZBpOU&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"https://x.com/brenogaribalde",
      },
      
      {
        cod: "6",
        imagem: `${process.env.PUBLIC_URL}/assets/06.webp`,
        nome: "Camilo Daniel ",
        partido: "Partido dos Trabalhadores (PT)",
        nomeCivil: "Camilo Daniel ",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "camilodaniel@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Camilo Daniel é filho de assentados da reforma agrária, cresceu nas trincheiras de luta do Movimento Sem Terra- MST. Estudou no Colégio Municipal Presidente Vargas e na Escola Estadual Dom Luciano, onde militou no movimento estudantil. É graduado em Ciências Sociais pela Universidade Federal de Sergipe- UFS e mestre em Desenvolvimento Territorial pela Universidade Estadual Paulista - Unesp. Atua em defesa dos direitos dos trabalhadores, do direito à moradia através dos movimentos populares, da alimentação saudável, da agricultura urbana, da educação pública, da soberania e segurança alimentar. Possui forte vínculo com os sindicatos e movimento comunitário. No final de 2023, assumiu o mandato como vereador, após o falecimento da vereadora Professora Ângela.",
        comissoes: [
          {
            cargo: "Membro",
            permanente: "Saúde, Meio Ambiente e Proteção Animal.",
          },
          {
            cargo: "Membro",
            permanente: "Educação, Cultura, Esportes, Lazer e Turismo..",
          },
        ],
        facebookLink:"https://www.facebook.com/@camiloaracaju/",
        instagramLink:"https://www.instagram.com/camiloaracaju/",
        youtubeLink:"https://www.youtube.com/watch?v=YRsKcI30Tv0&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"",
      },
      
      {
        cod: "7",
        imagem: `${process.env.PUBLIC_URL}/assets/07.webp`,
        nome: "Elber Batalha Filho",
        partido: "Partido Socialista Brasileiro (PSB)",
        nomeCivil: "Elber Batalha Filho",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "elberbatalha@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Elber Batalha Filho nasceu em Aracaju, no dia 20 de novembro de 1973. Ele é Defensor Público, ex-Secretário da Cultura do Estado de Sergipe, ex-Secretário do Turismo do Estado de Sergipe, mestrando em Direito Constitucional, Ex-Presidente do PSB de Aracaju e Vereador de Aracaju. O parlamentar começou sua vida política nos movimentos estudantis universitários da cidade. Foi eleito vereador por Aracaju em sua primeira candidatura e com um ano de mandato prestou concurso para a Defensoria Pública do Estado, onde exerce paralelamente as funções de defensor público e vereador. ",
        comissoes: [
          {
            cargo: "Membro",
            permanente: "Constituição, Justiça e Redação.",
          },
          {
            cargo: "Membro",
            permanente: "Finanças, Tomada de Contas e Orçamento.",
          },
        ],
        facebookLink:"https://www.facebook.com/elberbatalha.se",
        instagramLink:"https://www.instagram.com/elberbatalha/",
        youtubeLink:"https://www.youtube.com/watch?v=KJ1htkpeZ9I&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"https://x.com/elberbatalha",
      },
      
      {
        cod: "8",
        imagem: `${process.env.PUBLIC_URL}/assets/08.webp`,
        nome: "Fábio Meireles",
        partido: "Partido Democrático Trabalhista (PDT)",
        nomeCivil: "Fábio Meireles de Oliveira",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "fabiomeireles@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Nascido em Aracaju, Fábio Meireles de Oliveira foi eleito como vereador em Aracaju por 3 vezes. Tem 47 anos, é casado com Ítala e tem 02 filhos. Em sua atuação na Câmara, elaborou projetos de impacto social, como a regulamentação do programa de vacinação itinerante nas escolas de educação infantil e creches públicas e particulares,Seu lema é “Chamado para servir”.",
        comissoes: [
          {
            cargo: "Membro",
            permanente: "Finanças, Tomada de Contas e Orçamento.",
          },
        ],
        facebookLink:"",
        instagramLink:"https://www.instagram.com/vereadorfabiomeireles/",
        youtubeLink:"https://www.youtube.com/watch?v=vyMe0703Xcw&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"",
      },
      
      {
        cod: "9",
        imagem: `${process.env.PUBLIC_URL}/assets/09.webp`,
        nome: "Iran Barbosa",
        partido: "Partido Socialismo e Liberdade (PSOL)",
        nomeCivil: "José Iran Barbosa Filho",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "iranbarbosa@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
       
        biografia: "José Iran Barbosa Filho, o Professor Iran, nasceu em Aracaju. Graduou-se em História (Licenciatura Plena) pela Universidade Federal de Sergipe (UFS), em 1988. Em 1989, retornou aos bancos da UFS e, em 1992, colou grau mais uma vez, como bacharel em Direito. Em 1988, conseguiu a primeira colocação no Concurso Público para Professor de História da Secretaria de Estado da Educação de Sergipe e, em 2002, passou a acumular, como permitido pela Constituição Federal, o cargo de Professor de História na Secretaria Municipal de Educação de Aracaju. Em 2004, disputou uma cadeira na Câmara Municipal de Aracaju, tendo sido o segundo candidato mais bem votado para Vereador da capital sergipana. Em 2006, foi eleito Deputado Federal para a 53ª Legislatura da Câmara dos Deputados. Em 2012, Iran Barbosa foi eleito, mais uma vez, Vereador em Aracaju, na condição de candidato mais votado nas eleições proporcionais municipais daquele ano. Nas eleições municipais de 2016, o povo de Aracaju reconduziu Iran Barbosa como Vereador e, outra vez, como o mais votado da capital, com 8.809 votos. Em 28 de março de 2022, Iran Barbosa filiou-se ao Partido Socialismo e Liberdade – PSOL. Em 2025, ele segue para o seu quarto mandato.",

        comissoes: [
          {
            cargo: "Presidente",
            permanente: "Educação, Cultura, Esportes, Lazer e Turismo.",
          },
        ],
        facebookLink:"https://www.facebook.com/IranBarbosaOficial/?locale=pt_BR",
        instagramLink:"https://www.instagram.com/iranbarbosaoficial/",
        youtubeLink:"https://www.youtube.com/channel/UCC7J3W1WA1wzxrCBcWlQ7Jg",
        XLink:"https://x.com/Iran_Barbosa/status/1856306085704921354",
        LinkSite: "https://iranbarbosa.com.br/",
      },
      
      {
        cod: "10",
        imagem: `${process.env.PUBLIC_URL}/assets/10.webp`,
        nome: "Isac",
        partido: "União Brasil",
        nomeCivil: "Isac de Oliveira Silveira",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "isac@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Isac de Oliveira Silveira, conhecido como Isac (PDT), nasceu em 19 de julho de 1971. É formado em História pela Universidade Federal de Sergipe e já trabalhou como servidor público federal do INSS – Instituto Nacional de Seguro Social. Além disso, já foi coordenador-geral do Sindiprev/SE por três vezes, maior sindicato federal de Sergipe, que representa servidores da saúde, trabalho e previdência. Isac Silveira também já foi tesoureiro da Central Única dos Trabalhadores (CUT) de Sergipe. Em 2016, candidatou-se pela primeira vez e foi eleito pelo PCdoB, com 4.428 votos. Em 2024, já no PDT, Isac foi reeleito com 3.337 votos. Atualmente, ele está em seu terceiro mandato como vereador, eleito com 4.191 votos pelo União Brasil. ",
        comissoes: [
          {
            cargo: "Membro",
            permanente: "Constituição, Justiça e Redação.",
          },
          {
            cargo: "Membro",
            permanente: "Processante e Ética.",
          },
        ],
        facebookLink:"https://www.facebook.com/vereadorisacsilveira",
        instagramLink:"https://www.instagram.com/vereadorisacsilveira/",
        youtubeLink:"https://www.youtube.com/watch?v=jvlLMSZIMtM&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"https://x.com/IsacSilveiraAju",
      },
      
      {
        cod: "11",
        imagem: `${process.env.PUBLIC_URL}/assets/11.webp`,
        nome: "Joaquim da Janelinha",
        partido: "Partido Democrático Trabalhista (PDT)",
        nomeCivil: "José Joaquim Santos Nascimento,",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "joaquimdajanelinha@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "José Joaquim Santos Nascimento, mais conhecido como Joaquim da Janelinha (PDT), nasceu em 15/05/1981 na capital sergipana. Iniciou sua vida política em 2006, na organização de campanha política. Joaquim é professor e gestor escolar. Está em sua 2º Legislatura na Câmara Municipal de Aracaju. O parlamentar foi eleito pela primeira vez em 2020, pelo Partido Republicano da Ordem Social (Pros), com 2.829 votos. Em 2024, tendo 4.804 votos, ele foi reeleito pelo Partido Democrático Trabalhista (PDT). Suas principais bandeiras são a educação e o emprego para jovens. Tem projetos sociais nos bairros Augusto Franco, Santa Maria e São Conrado",
        comissoes: [
          {
            cargo: "",
            permanente: "",
          },
        ],
        facebookLink:"https://www.facebook.com/joaquimdajanelinha/",
        instagramLink:"https://www.instagram.com/joaquimdajanelinha/",
        youtubeLink:"",
        XLink:"https://x.com/JanelinhadoSabe",
      },
      
      {
        cod: "12",
        imagem: `${process.env.PUBLIC_URL}/assets/12.webp`,
        nome: "Levi Oliveira",
        partido: "Progressistas (PP)",
        nomeCivil: "Levi Santos de Oliveira Filho",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "levioliveira@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Levi Santos de Oliveira Filho, nascido em 1988, natural de Recife/PE, é empresário, administrador e vereador de Aracaju no primeiro mandato. Formado em Administração, assumiu, em 2014, a direção da L&M Sustentabilidade, empresa vinculada ao Grupo Multserv. Motivado a contribuir com o desenvolvimento de Aracaju, lançou sua candidatura a vereador em 2024, sendo eleito com 4.109 votos pelo Partido Progressista (PP). Na Câmara Municipal, tem como foco a inclusão social, a sustentabilidade e a promoção de oportunidades para todos os cidadãos da cidade.",
        comissoes: [
          {
            cargo: "Secretário",
            permanente: "Finanças, Tomada de Contas e Orçamento.",
          },
        ],
        facebookLink:"https://www.facebook.com/levi.oliveira.75",
        instagramLink:"https://www.instagram.com/levioliveirasergipe/",
        youtubeLink:"https://www.youtube.com/watch?v=n9Uv1wMNfp8&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"",
      },
      
      {
        cod: "13",
        imagem: `${process.env.PUBLIC_URL}/assets/13.webp`,
        nome: "Lúcio Flávio",
        partido: "Partido Liberal (PL)",
        nomeCivil: "Lúcio Flávio Rocha",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "lucioflavio@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Nascido em 13 de janeiro de 1979, Lúcio Flávio Rocha iniciou sua atuação política em movimentos de direita, desde 2014. Lúcio é casado com Valéria Rocha, pai de um casal. Graduado em Comunicação Social, com habilitação em Publicidade & Propaganda e pós-graduado em Marketing, Lúcio é empreendedor, professor universitário, co-fundador do Movimento Brasil200 e fundador da Marcha da Família. Eleito vereador com 3.847 votos pelo Partido Liberal (PL), na base de apoio da prefeita Emília Corrêa. Lúcio Flávio assume também a Presidência da Frente Parlamentar em defesa da vida e da família. ",
        comissoes: [
          {
            cargo: "Membro",
            permanente: "Saúde, Meio Ambiente e Proteção Animal.",
          },
          {
            cargo: "Membro",
            permanente: "Assistência Social, Direitos Humanos, Defesa Do Consumidor, Criança, Adolescente e da Mulher.",
          },
        ],
        facebookLink:"https://www.facebook.com/lucioflaviose",
        instagramLink:"https://www.instagram.com/lucioflaviose/",
        youtubeLink:"https://www.youtube.com/watch?v=lR8DeCOLH5U&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"",
      },

         {
        cod: "29",
        imagem: `${process.env.PUBLIC_URL}/assets/29.webp`,
        nome: "Marcel Azevedo",
        partido: "Partido Socialista Brasileiro (PSB)",
        nomeCivil: "Marcel Vinícius Cunha Azevêdo",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "marcelazevedo@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia: "Da linha de frente à Câmara Municipal: Marcel Azevedo leva a voz da enfermagem para o Legislativo de Aracaju Com uma trajetória marcada pela atuação dedicada à saúde pública e à valorização da enfermagem, o enfermeiro e professor universitário Marcel Vinícius Cunha Azevedo assume, na tarde desta terça-feira, 22 de julho de 2025, uma cadeira na Câmara Municipal de Aracaju. Ele entra como suplente no lugar do vereador Rodrigo Fontes (PSB), que se licencia do mandato por 180 dias. Para além da nova função parlamentar, Marcel carrega uma bagagem construída nas salas de aula, nos corredores hospitalares e nas lutas institucionais em defesa da categoria da qual faz parte há 15 anos. Nascido em Aracaju, em 1988, Marcel é filho de Flávio e Clara, irmão de Ana Flávia, casado com Juliana e pai de Ted. Formou-se em Enfermagem pela Universidade Tiradentes (UNIT) em 2010 e, desde então, consolidou sua carreira no serviço público. Atuou como enfermeiro assistencial por oito anos no Hospital Cirurgia e por mais de três anos no Hospital de Urgência de Sergipe (HUSE). Durante a pandemia de COVID-19, esteve na linha de frente do combate à doença, trabalhando na assistência tanto no HUSE quanto no Ipesaúde. Além da prática clínica, Marcel trilhou um percurso sólido no campo da educação. Foi professor em diversos cursos técnicos de enfermagem no interior de Sergipe e coordenou, por sete anos, o curso de Enfermagem da Estácio Sergipe. Atualmente, leciona na UNIT e atua como coordenador de pós-graduação na mesma instituição, sempre voltado à formação de profissionais comprometidos com a humanização do cuidado e a qualidade dos serviços de saúde. Sua atuação política ganhou força por meio do Conselho Regional de Enfermagem de Sergipe (COREN-SE), onde está em seu segundo mandato, agora como presidente — cargo que ocupa desde 2024, após ter sido conselheiro. À frente da entidade, tem liderado pautas importantes como a luta pelo cumprimento do piso salarial da enfermagem, melhores condições de trabalho e valorização da categoria. Recentemente, esteve em audiência com o Ministério Público de Sergipe para debater o repasse do complemento do piso nacional, reforçando seu compromisso com a classe que representa."+
        'Ao assumir a cadeira na Câmara de Aracaju, Marcel Azevedo amplia o alcance de sua voz. Passa a representar, também no parlamento municipal, os profissionais de enfermagem e os usuários do sistema público de saúde. Seu mandato, ainda que temporário, nasce do cotidiano da assistência e do diálogo com a categoria, com a proposta de construir políticas públicas que respeitem e reconheçam a importância da saúde como direito e da enfermagem como base essencial do cuidado.',
        comissoes: [
          {
            cargo: "",
            permanente: "",
          },
        ],
        facebookLink:"",
        instagramLink:"https://www.instagram.com/marcel.azevedo.enf?igsh=MWE4NndnbGx4aHQ0Zg==",
        youtubeLink:"",
        XLink:"",
      },
      
      {
        cod: "14",
        imagem: `${process.env.PUBLIC_URL}/assets/14.webp`,
        nome: "Maurício Maravilha",
        partido: "União Brasil",
        nomeCivil: "Maurício Santos Costa",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "mauriciomaravilha@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Maurício Santos Costa, conhecido como Maurício Maravilha, tem 33 anos, natural de Umbaúba/SE, é graduado e pós-graduado em engenharia civil, com especialização em Gerenciamento de Obras e Tecnologia da Construção. Trabalhou por cinco anos em construtoras privadas e sete anos à frente da pasta de Obras na gestão pública, onde liderou projetos de infraestrutura que transformaram a qualidade de vida da população de Aracaju. Recém-eleito vereador pelo União Brasil, Maurício representa uma nova geração de liderança, unindo juventude, experiência e determinação. Sua atuação é impulsionada pela inquietude de quem busca soluções inovadoras para os desafios da sociedade, com o objetivo de construir um futuro mais justo, eficiente e sustentável para todos.",
        comissoes: [
          {
            cargo: "Membro",
            permanente: "Finanças, Tomada de Contas e Orçamento.",
          },
          {
            cargo: "Presidente",
            permanente: "Obras, Serviços Públicos, Tecnologia, Segurança, Administração, Transportes e Comércio.",
          },
        ],
        facebookLink:"",
        instagramLink:"https://www.instagram.com/mauricio.maravilha/",
        youtubeLink:"https://www.youtube.com/watch?v=RpRRGeyGZz4&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"",
      },
      
      {
        cod: "15",
        imagem: `${process.env.PUBLIC_URL}/assets/15.webp`,
        nome: "Miltinho Dantas",
        partido: "Partido Social Democrático (PSD)",
        nomeCivil: "Mílton Dantas de Farias Júnior",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "miltinho@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Mílton Dantas de Farias Júnior, carinhosamente conhecido como Miltinho, nasceu no dia 05 de outubro de 1967, em Aracaju/SE. Filho de Mílton Dantas de Farias e de Maria José de Araújo, Miltinho é o segundo mais velho dos filhos do casal, um deles o emblemático e saudoso desportista Juca Dantas, irmão que lhe transmitiu a paixão pelo futebol. Miltinho Dantas iniciou sua vida profissional como comerciário aos quatorze anos de idade, tornando-se bancário aos vinte, quando ingressou no banco Bradesco, onde viria a trabalhar durante trinta anos. E foi na labuta bancária que despertou para a luta pelos trabalhadores, tomando parte na direção do sindicato de sua categoria."+ 
          "Ao ativismo trabalhista, Miltinho agregou a luta pelo futebol sergipano, inicialmente como Diretor de Futebol da Associação Desportiva Confiança, chegando à presidência do Dragão, onde imprimiu um estilo de gestão inovador e bastante exitoso. Seu sucesso como gestor de clube o alçou à vice-presidência da Federação Sergipana de Futebol, à diretoria da Liga do Nordeste e à presidência da Federação Sergipana de Futebol."+  
          "E foi sua opção pelos trabalhadores e socialmente desfavorecidos, juntamente com sua percepção do potencial do esporte como alavanca para a inclusão social, que o levou ao universo político, incialmente como vereador suplente, assumindo e exercendo o mandato durante quase um ano, até alcançar a eleição plena no ano de 2024 pelo PSD. Miltinho é pai de cinco filhos e avô de três netas.",
        comissoes: [
          {
            cargo: "Secretário",
            permanente: "Educação, Cultura, Esportes, Lazer e Turismo.",
          },
        ],
        facebookLink:"",
        instagramLink:"https://www.instagram.com/miltinhodantas/",
        youtubeLink:"https://www.youtube.com/watch?v=vuWfXoN8kXI&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"",
      },
      
      {
        cod: "16",
        imagem: `${process.env.PUBLIC_URL}/assets/16.webp`,
        nome: "Moana Valadares",
        partido: "Partido Liberal (PL)",
        nomeCivil: "Moana Rolemberg Marinho Valadares",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "moanavaladares@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Moana Rolemberg Marinho Valadares, 31 anos, é casada e tem dois filhos: Luísa (11 anos) e Pedro (9 anos). É advogada e exerce o primeiro mandato como vereadora eleita por Aracaju. Foi eleita pelo partido liberal (PL), com 7216 votos, sendo a vereadora mais votada da história de Aracaju. Ela é cristã e defende as bandeiras conservadoras. Ela se compromete a ser uma voz atuante na Câmara de Vereadores de Aracaju a partir de 2025.",
        comissoes: [
          {
            cargo: "Membro",
            permanente: "Educação, Cultura, Esportes, Lazer e Turismo.",
          },
          {
            cargo: "Membro",
            permanente: "Processante e Ética.",
          },
        ],
        facebookLink:"",
        instagramLink:"https://www.instagram.com/moanavaladares/",
        youtubeLink:"https://www.youtube.com/watch?v=wjfo2d-B71g&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"",
        LinkTikTok:"https://www.tiktok.com/@moanavaladares_?_t=ZM-8tCWNJKQ3TZ&_r=1",
      },
      
      {
        cod: "17",
        imagem: `${process.env.PUBLIC_URL}/assets/17.webp`,
        nome: "Pastor Diego",
        partido: "União Brasil",
        nomeCivil: "Vítor Diego Lima Fortunato",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "pastordiego@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Vítor Diego Lima Fortunato, conhecido como Pastor Diego (PP), nasceu em 29 de dezembro de 1992. Em 2025, seguirá para o 2º mandato como vereador. Pastor Diego é advogado por formação, trabalhou no centro de Aracaju como vendedor e faz parte da Comissão de Justiça, Redação e Ética da Câmara. O vereador possui projetos de cursos profissionalizantes pelos bairros de Aracaju e defende os direitos da população, a família, os valores e princípios cristãos. ",
        comissoes: [
          {
            cargo: "Presidente",
            permanente: "Constituição, Justiça e Redação.",
          },
          {
            cargo: "Membro",
            permanente: "Processante e Ética.",
          },
        ],
        facebookLink:"https://www.facebook.com/vereadorpastordiego",
        instagramLink:"https://www.instagram.com/_pastordiego/",
        youtubeLink:"https://www.youtube.com/channel/UCZX6u175YQng6C5KUrUGtnQ",
        XLink:"https://x.com/_pastordiego",
        LinkTikTok:"https://www.tiktok.com/@_pastordiego/",
        LinkSite:"https://pastordiego.com.br/",
      },
      
      {
        cod: "18",
        imagem: `${process.env.PUBLIC_URL}/assets/18.webp`,
        nome: "Professora Sonia Meire",
        partido: "Partido Socialismo e Liberdade (PSOL)",
        nomeCivil: "Sonia Meire",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "professorasoniameire@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Sonia Meire é mãe, avó, pedagoga de formação, ex-professora da rede municipal de Aracaju, da rede estadual e por mais de 20 anos da Universidade Federal de Sergipe. Pesquisadora, participou da elaboração e aplicação de políticas públicas para assentados e acampados da reforma agrária, desenvolveu projetos de alfabetização popular e trabalhou com comunidades extrativistas. Como sindicalista participou da construção do SINTESE, ADUFS e ANDES. Nos últimos anos tem se destacado pela atuação no movimento de mulheres. Foi candidata ao governo de Sergipe em 2014 pelo PSOL com mais de 40 mil votos e ao Senado em 2018 com mais de 60 mil votos. Em 2020 foi a oitava vereadora mais votada de Aracaju, sendo a primeira suplente da câmara. Nas eleições de 2022 disputou como deputada federal pelo PSOL para ser a primeira mulher eleita para a Câmara federal por Sergipe. Em 2 de fevereiro de 2023 assumiu o cargo de vereadora na Câmara Municipal de Aracaju ocupando a vaga da vereadora Linda Brasil que foi para a ALESE e em 2025, segue na Câmara parlamentar. ",
        comissoes: [
          {
            cargo: "Membro",
            permanente: "Constituição, Justiça e Redação.",
          },
          {
            cargo: "Secretária",
            permanente: "Assistência Social, Direitos Humanos, Defesa Do Consumidor, Criança, Adolescente e da Mulher.",
          },
        ],
        facebookLink:"https://www.facebook.com/professorasoniameire",
        instagramLink:"https://www.instagram.com/professorasoniameire/",
        youtubeLink:"https://www.youtube.com/c/ProfessoraSoniaMeire",
        XLink:"https://x.com/profsoniameire",
        LinkSite:"https://soniameire.com.br/",
      },
      
      {
        cod: "19",
        imagem: `${process.env.PUBLIC_URL}/assets/19.webp`,
        nome: "Ricardo Vasconcelos",
        partido: "Partido Social Democrático (PSD)",
        nomeCivil: "Ricardo Vasconcelos Silva",
        telefone: "(79) 0000-0000",
        celular: "(79) 00000-00000",
        email: "ricardovasconcelos@aracaju.se.leg.br",
        gabinete: "Rua, Nº, Aracaju",
        biografia:
          "Ricardo Vasconcelos Silva, nasceu em 06 de dezembro de 1984 na capital sergipana. É advogado, servidor público da DESO, casado com Thaine Garcia, pai de Gabriel e Felipe. O parlamentar está em seu 2ª mandato, e em janeiro 2025 foi reeleito presidente da Câmara Municipal de Aracaju (CMA)."+ 
          "Ricardo tem se destacado pela forma democrática, transparente e eficiente que vem atuando a frente da presidência da CMA, a capacidade de dialogar de forma pacifica e harmoniosa com a oposição e situação da Casa tem trazido bons resultados durante as votações de Projetos, acelerando o ritmo de trabalho, apreciando e aprovando projetos que favorecem a população aracajuana."+ 
          "A aproximação da população com a Câmara também é um marco da gestão de Ricardo, que tem focado na realização de Audiências Públicas, além do diálogo com a  sociedade, sempre buscando ouvir as demandas das comunidades para viabilizar a solução de diversas problemáticas."+
          "Além disso, como servidor público, Ricardo procura valorizar o funcionalismo público, estabelecendo dialogo com os servidores públicos municipais da administração geral, SMTT e Guarda Municipal, o que garantiu o cumprimento dos direitos e beneficios durante as votações de Projetos enviados pelo Executivo para a CMA."+
          "Outro ponto de atuação do mandato do parlamentar, é a preservação do meio ambiente para as futuras gerações, um exemplo disso foi a aprovação  do Projeto de Lei que dispõe sobre o Programa de recuperação e preservação da permeabilidade do solo no município de Aracaju de autoria do vereador."+
          "A trajetória política de Ricardo Vasconcelos tem sido uma demonstração de política feita para o povo e pelo povo. De forma visionária, justa e igualitária, trilhando um futuro promissor, sempre buscando garantir a esperança de dias melhores para o povo aracajuano.",
        comissoes: [
          {
            cargo: "",
            permanente: "",
          },
        ],
        facebookLink:"https://www.facebook.com/ricardovasconcelos.aju/",
        instagramLink:"https://www.instagram.com/ricardovasconcelos.aju/",
        youtubeLink:"https://www.youtube.com/watch?v=c9fR3GfiNu0&ab_channel=C%C3%A2maraMunicipaldeAracaju",
      },
      
      {
        cod: "20",
        imagem: `${process.env.PUBLIC_URL}/assets/20.webp`,
        nome: "Rodrigo Fontes",
        partido: "Partido Socialista Brasileiro (PSB)",
        nomeCivil: "Rodrigo Fontes Almeida ",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "rodrigofontes@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Rodrigo Fontes Almeida (PSB) foi eleito vereador de Aracaju com 2.496 votos de todas as três zonas eleitorais da capital. Nascido em 21 de maio de 1975, Rodrigo tem 49 anos e é natural de Aracaju-SE. Fontes é casado com Simone Machado Mota Almeida desde 10 de junho de 1996. Rodrigo é pai de José Jonas, seu primogênito e filho de um relacionamento anterior. Com Simone, Rodrigo teve mais três filhos: Nilza, Marília e Rodrigo Filho.Ele está em seu primeiro mandato na Câmara Municipal de Aracaju e foi eleito pelo PSD com 2.496 votos.",
        comissoes: [
          {
            cargo: "Membro",
            permanente: "Saúde, Meio Ambiente e Proteção Animal.",
          },
        ],
        facebookLink:"",
        instagramLink:"https://www.instagram.com/vereadorrodrigofontes/",
        youtubeLink:"https://www.youtube.com/watch?v=2iDt23gYRnM&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"",
      },
      
      {
        cod: "21",
        imagem: `${process.env.PUBLIC_URL}/assets/21.webp`,
        nome: "Sávio Neto de Vardo da Lotérica",
        partido: "Podemos",
        nomeCivil: "José Sávio Gois Silva",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "savionetodevardo@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "José Sávio Gois Silva, o Sávio Neto de Vardo, tem 29 anos, nasceu no dia 12 de setembro de 1995, filho de Adelmo e Valmira. Itabaianenses que, desde cedo, mostraram o valor do trabalho e da ética ao filho mais velho. É irmão de Maria Stefany e José Sidney; esposo de Vitória. Em 2020 foi eleito pelo PSC com 2.409 votos. Em 2024, retornando à Câmara de Aracaju, eleito com 2.872 votos. Sávio também é um defensor da classe rodoviária. Atuando no ramo desde os 15 anos de idade, hoje também é empresário da Cooperativa de ônibus Coopertalse, considerada a maior do Nordeste. ",
        comissoes: [
          {
            cargo: "Membro",
            permanente: "Obras, Serviços Públicos, Tecnologia, Segurança, Administração, Transportes e Comércio.",
          },
        ],
        facebookLink:"",
        instagramLink:"https://www.instagram.com/vereadorsavionetodevardo",
        youtubeLink:"https://www.youtube.com/watch?v=HUFPj2Fcy-E&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"",
      },
      
      {
        cod: "22",
        imagem: `${process.env.PUBLIC_URL}/assets/22.webp`,
        nome: "Selma França",
        partido: "Partido Social Democrático (PSD)",
        nomeCivil: "Regina Selma França Cruz",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "selmafrança@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Regina Selma França Cruz, mais conhecida como Selma França, nasceu em Aracaju, no dia 19 de maio de 1960. Mãe de quatro filhos – Dalva, César, Rafael e Guilherme – e avó de quatro netos, Selma é formada em Pedagogia pela Universidade Federal de Sergipe. Sua trajetória sempre esteve pautada na assistência social, área onde construiu uma carreira marcada pelo compromisso com a comunidade." +
          "Selma tentou por quatro vezes o cargo de vereadora, ficando como 1ª suplente em todas as ocasiões, como em 2016, quando conquistou 2.225 votos. Hoje, ela faz história ao tomar posse como a primeira mulher eleita vereadora por Aracaju pelo PSD, com um total de 3.718 votos.",
        comissoes: [
          {
            cargo: "Membro",
            permanente: "Saúde, Meio Ambiente e Proteção Animal.",
          },
          {
            cargo: "Presidente",
            permanente: "Assistência Social, Direitos Humanos, Defesa Do Consumidor, Criança, Adolescente e da Mulher.",
          },
        ],
        facebookLink:"https://www.facebook.com/selmafranca43333/",
        instagramLink:"https://www.instagram.com/selmafrancaaju",
        youtubeLink:"https://www.youtube.com/watch?v=ETQmvNHaG20&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"",
      },
      
      {
        cod: "23",
        imagem: `${process.env.PUBLIC_URL}/assets/23.webp`,
        nome: "Sgt. Byron Estrelas do Mar",
        partido: "Movimento Democrático Brasileiro (MDB)",
        nomeCivil: "Byron Virgílio dos Santos Silva",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "sgtbyronestrelasdomar@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Byron Virgílio dos Santos Silva, nascido em Aracaju, em 29 de junho de 1978, é filho de Maria Iraci dos Santos Silva e Hercílio José dos Santos Silva. Nasceu e cresceu no bairro Atalaia. Pai de Luna Morena e Byron Emanuel, é casado com Anne Bastos. Conhecido como Sgt. Byron do Estrelas do Mar, é Policial Militar de Sergipe, idealizador do projeto social Estrelas do Mar, bodyboarder e bacharel em Direito pela Universidade Tiradentes (Unit). No ano de 2020, colocou-se, pela primeira vez, como candidato a vereador, e foi vitorioso no pleito a Câmara Municipal de Aracaju, eleito com 1.743 votos. Em 2025, exercerá o seu 2º mandato como vereador. ",
        comissoes: [
          {
            cargo: "",
            permanente: "",
          },
        ],
        facebookLink:"https://www.facebook.com/byron.silvaa/",
        instagramLink:"https://www.instagram.com/byronestrelasdomar/",
        youtubeLink:"https://www.youtube.com/watch?v=MCo4KzerTSg&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"",
      },
      
      {
        cod: "24",
        imagem: `${process.env.PUBLIC_URL}/assets/24.webp`,
        nome: "Soneca",
        partido: "Partido Social Democrático (PSD)",
        nomeCivil: "Alexsandro da Conceição",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "soneca@aracaju.se.leg.br ",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Alexsandro da Conceição, conhecido como Soneca (PSD), nasceu em 27 de junho de 1986. Soneca é humorista, iniciou na política em 2012 e está na sua terceira Legislatura na Câmara Municipal de Aracaju. Ele foi eleito vereador pela primeira vez em 2016, quando conquistou 2.657 votos pelo partido PPS. Em 2020, foi reeleito com 3.280 votos. Nas eleições de 2024, Soneca concorreu pelo PSD e foi o 19º vereador mais votado com 3.234 votos. Antes de se eleger vereador, Soneca se apresentava em praças públicas, nas escolas e demais espaços públicos, levando a arte circense. Possui curso superior em Gestão Pública, além de curso técnico em Rádio e TV. ",
        comissoes: [
          {
            cargo: "Membro",
            permanente: "Obras, Serviços Públicos, Tecnologia, Segurança, Administração, Transportes e Comércio.",
          },
          {
            cargo: "Membro",
            permanente: "Processante e Ética.",
          },
        ],
        facebookLink:"https://www.facebook.com/vereadorpalhacosoneca",
        instagramLink:"https://www.instagram.com/vereadorsoneca/",
        youtubeLink:"",
        XLink:"",
      },
      
      {
        cod: "25",
        imagem: `${process.env.PUBLIC_URL}/assets/25.webp`,
        nome: "Thannata da Equoterapia",
        partido: "Partido da Mobilização Nacional (Mobiliza)",
        nomeCivil: "Thannata Stefany Aragão Oliveira",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "thannatadaequoterapia@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Thannata Stefany Aragão Oliveira, conhecida como Thannata da Equoterapia, nasceu em Aracaju, no dia 13/10/2001, tem 23 anos. Estudante de Terapia Ocupacional, dedicou sua vida a ajudar quem mais precisa, com Deus e sua família como pilares fundamentais. Eleita aos 22 anos, pelo partido Mobiliza, obteve 2.271 votos e tornou-se a vereadora mais jovem da história de Aracaju. Lidera há mais de três anos na Equoterapia no Batalhão da Restauração, onde oferece atendimento gratuito para mais de 600 pessoas com deficiência e suas famílias. Sua atuação na Câmara Municipal prioriza a inclusão, a saúde e os projetos sociais, com o objetivo de construir uma Aracaju mais digna e acolhedora para todos. ",
        comissoes: [
          {
            cargo: "Membro",
            permanente: "Assistência Social, Direitos Humanos, Defesa Do Consumidor, Criança, Adolescente e da Mulher.",
          },
        ],
        facebookLink:"",
        instagramLink:"https://www.instagram.com/thannatadaequoterapia/",
        youtubeLink:"https://www.youtube.com/watch?v=PEzv89iNn4k&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"",
      },
      
      {
        cod: "26",
        imagem: `${process.env.PUBLIC_URL}/assets/26.webp`,
        nome: "Vinicius Porto",
        partido: "Partido Democrático Trabalhista (PDT)",
        nomeCivil: "Vinicius Porto Menezes",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "viniciusporto@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Vinicius Porto Menezes, mais conhecido como Vinicius Porto (PDT), nasceu em 09/05/1976. Iniciou sua vida na política em 2005. Mas antes disso se graduou em Direito. Na Câmara Municipal de Aracaju, exerceu o cargo de presidente entre 2013 e 2016. Faz parte da Comissão de Finanças, Tomada de Contas e Orçamento. Suas principais bandeiras são a geração de emprego, saúde e educação. Em 2025, irá para a sua 5ª legislatura.",
        comissoes: [
          {
            cargo: "Presidente",
            permanente: "Finanças, Tomada de Contas e Orçamento.",
          },
        ],
        facebookLink:"",
        instagramLink:"https://www.instagram.com/viniciusporto/",
        youtubeLink:"https://www.youtube.com/watch?v=WCIetZfc72w&ab_channel=C%C3%A2maraMunicipaldeAracaju",
        XLink:"",
      },
      
      {
        cod: "27",
        imagem: `${process.env.PUBLIC_URL}/assets/27.webp`,
        nome: "Nitinho",
        partido: "Partido Social Democrático (PSD)",
        nomeCivil: "Josenito Vitale de Jesus",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "nitinho@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia:
          "Nitinho Vitale, 57 anos, vereador de Aracaju,  é pai de Letícia e Leonardo. Nascido em Aracaju, no dia 31 de maio de 1966, Nitinho é filho de José Alves de Jesus, conhecido como Sargento Jesus, e Benedita Vitale. O pai faleceu em 1988 e a mãe em 1998. Nitinho, - atualmente filiado ao Partido Social Democrata - PSD, sob a presidência do governador eleito Fábio Mitidieri - , estreou na política filiado ao antigo Partido da Frente Liberal – PFL, sob a liderança do ex-governador de Sergipe e ex-ministro do Interior, engenheiro João Alves Filho. Em 2025, exerce o sétimo mandato de vereador. Em 2022,  finalizou o terceiro biênio no exercício da presidência do Legislativa Municipal. Nitinho cresceu no conjunto Castelo Branco, na capital sergipana, tendo uma infância tranquila e feliz, ao gozar de plena liberdade para brincar nas ruas e correr nos campos de várzeas. Carismático desde a infância, ainda aos 6 anos, Nitinho conquistou o carinho dos mais idosos, ajudando-os com pequenos favores, como pagamentos em casas lotéricas e compras em mercearias do bairro. Inquieto na busca de autonomia financeira, aos 11 anos, já morando na Rua Simão Dias, no centro da cidade, passou a ganhar poucos trocados com serviços , como fazer transporte de mercadorias nos supermercados da vizinhança. Já nesta época, uma das rotinas de Nitinho era pernoitar nas calçadas do antigo INPS, atual INSS, para marcar o lugar na fila de usuários que buscavam atendimento, para  consultas e exames de saúde. Dessa forma simples, embora sacrificante, Nitinho encontrou um meio de ajudar a família e ter o próprio dinheiro. Mas, foi no início da vida adulta, guardando carros em frente a escolas e em uma faculdade particular, que fez ainda mais amigos, que no futuro mudariam sua vida com um projeto que nunca lhe havia passado pela cabeça: a carreira política. Amigueiro e prestativo, acreditou no sonho coletivo e conseguiu converter seus antigos contratantes em amigos, que o acompanham, admiram-no e o elegem até os dias atuais. Como ele mesmo define, a carreira política nasceu “Pelas mãos dos Amigos”. Alegre e festeiro, também se tornou o maior vendedor de fantasias de acesso a blocos carnavalescos da maior prévia do país, o Pré-Caju. Anualmente, no percurso da festa, montava um quiosque de lanches e bebidas, que se tornou parada obrigatória para os jovens foliões. Na labuta intensa desde muito cedo, Nitinho se tornou uma das figuras mais populares de Aracaju. Se a política não estava na cabeça dele, o curso de sua vida o levou a ela. Foi o incentivo dos amigos que o fez amadurecer a ideia de que poderia ajudar muita gente com um cargo eletivo. Sua primeira incursão teve fim dentro de casa. Em 1988, ao consultar o pai sobre entrar para a política, ouviu um não que o fez desistir do intuito. O futuro colocaria a política de novo em sua vida. Em 1992, tentou sua primeira eleição. Mesmo sendo um nome novo na política, já obteve 812 votos. Mas não foi o bastante para elegê-lo. Nitinho não se abateu e, na eleição seguinte, em 1996, se tornaria pela primeira vez vereador pela capital sergipana. Em 2000, foi mais uma vez candidato, mas perdeu a eleição. Isso não o abateu e, no dia seguinte, já estava na Câmara de Vereadores, desta vez, como vendedor de revistas e jornais. Com o apoio permanente dos amigos e sem a ajuda de nenhuma grande liderança política, em 2004, Nitinho conquistou a sua segunda vitória para a CMA. Ele voltou à Casa Legislativa ainda mais forte, com mais de 3 mil votos. Desde então, nunca mais perdeu nenhuma eleição e foi alçado, em 2017, ao cargo máximo da Câmara Municipal de Aracaju, a presidência. Em 31 de dezembro de 2022, Nitinho finalizou o terceiro biênio como presidente do Legislativo Municipal.",
        comissoes: [
          {
            cargo: "",
            permanente: "",
          },
        ],
        facebookLink:"https://www.facebook.com/nittinhovitale",
        instagramLink:"https://www.instagram.com/nitinhovitale/",
        youtubeLink:"",
        XLink:"",
        LinkSite: "https://nitinho.com.br/",
      }, 
      
      {
        cod: "28",
        imagem: `${process.env.PUBLIC_URL}/assets/28.webp`,
        nome: "Dr. Manuel Marcos",
        partido: "Partido Social Democrático (PSD)",
        nomeCivil: "Manuel Marcos dos Santos",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "drmanuelmarcos@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia: "Dr.  Manuel Marcos Dos  Santos nasceu em uma família humilde na cidade de Santo Amaro das Brotas Sergipe, mas desde jovem sonhava em superar as adversidades. Tornou-se médico e mais tarde entrou na vida pública, Vereador pelo partido  PSD por quartro  mandatos dedicando-se ao serviço humanitário e à saúde da comunidade. Sua jornada foi marcada pela abnegação, solidariedade e integridade, conquistando o respeito e admiração de todos ao seu redor. Sua história é um exemplo de superação e dedicação ao bem-estar dos outros, tanto na medicina quanto na política, deixando um legado de inspiração e bondade.",
        comissoes: [
          {
            cargo: "",
            permanente: "",
          },
        ],
        facebookLink:"https://www.facebook.com/DoutorManuelMarcos",
        instagramLink:"",
        youtubeLink:"",
        XLink:"",
      },
      
            {
        cod: "30",
        imagem: `${process.env.PUBLIC_URL}/assets/30.webp`,
        nome: "Avilé Dantas",
        partido: "Progressistas (PP)",
        nomeCivil: "Avilé Dantas",
        telefone: "(79) 0000-0000",
        celular: "(79) 99999-9999",
        email: "avile@aracaju.se.leg.br",
        gabinete: "Rua, Nº Aracaju",
        biografia: "",
        comissoes: [
          {
            cargo: "",
            permanente: "",
          },
        ],
        facebookLink:"",
        instagramLink:"",
        youtubeLink:"",
        XLink:"",
      },
  ];